import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// Import director/farmer images from assets
import farmer1 from '../../../assets/images/sunil3.jpg'; // Main farmer/founder
import farmer2 from '../../../assets/images/director2.jpg'; // Co-founder/partner

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const slides = [
    {
      id: 1,
      title: "ONE TIME INVESTMENT, CONTINUOUS RETURNS!",
      subtitle: "AT SIRIDHARINI",
      description: "Experience sustainable agriculture with guaranteed returns through our innovative farming solutions.",
      image: require("../../../assets/images/ourstory-heroimage.png"),
      accentColor: "#22c55e",
      gradientFrom: "#22c55e",
      gradientTo: "#16a34a",
      type: "main"
    },
    {
      id: 2,
      title: "SUSTAINABLE FARMING",
      subtitle: "Nature's Gift to Future Generations",
      description: "Organic farming practices that preserve the earth while providing exceptional yields.",
      image: require("../../../assets/images/amla-tree-A7V3JYF.jpg"),
      accentColor: "#16a34a",
      gradientFrom: "#16a34a",
      gradientTo: "#15803d",
      type: "farming"
    },
    {
      id: 3,
      title: "Meet Our Team",
      subtitle: "Experienced Agricultural Leaders",
      image: require("../../../assets/images/siridharini.jpeg"),
      accentColor: "#f97316",
      gradientFrom: "#f97316",
      gradientTo: "#ea580c",
      type: "team",
      team: [
        {
          name: "Sunil Kumar S",
          qualification: "Agricultural Expert & Founder",
          image: farmer1
        },
        {
          name: "Roopa Sunil Kumar",
          qualification: "Sustainable Farming Specialist",
          image: farmer2
        }
      ]
    },
    {
      id: 4,
      title: "FRESH FROM FARM TO TABLE",
      subtitle: "Pure, Natural, Nutritious",
      description: "Direct from our organic farms to your table - experience the difference of truly natural produce.",
      image: require("../../../assets/images/pomegrenate-1.jpg"),
      accentColor: "#f97316",
      gradientFrom: "#f97316",
      gradientTo: "#ea580c",
      type: "produce"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const currentSlideData = slides[currentSlide];

  const handleStartInvestment = () => {
    navigate('/whatweoffer');
  };

  const handleLearnMore = () => {
    navigate('/ourstory');
  };

  const handleExploreFarm = () => {
    navigate('/ourfarm');
  };

  const handleContactUs = () => {
    navigate('/about/contact');
  };

  const renderSlideContent = (slide, index) => {
    const isActive = index === currentSlide;

    if (slide.type === "main") {
      return (
        <div style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div style={{
            textAlign: 'center',
            opacity: isActive ? 1 : 0,
            transform: isActive ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 1.2s cubic-bezier(0.25, 0.1, 0.25, 1) 0.3s',
            width: '100%'
          }}>
            <p style={{
              fontSize: '1.1rem',
              lineHeight: '1.6',
              color: '#ffffff',
              fontWeight: '500',
              margin: '0 0 1rem 0',
              letterSpacing: '2px',
              textTransform: 'uppercase'
            }}>
              {slide.title}
            </p>

            <h1 style={{
              fontSize: '4.5rem',
              fontWeight: '800',
              marginBottom: '1.5rem',
              lineHeight: '1.1',
              color: '#ffffff',
              letterSpacing: '-0.02em',
              textShadow: '0 4px 20px rgba(0, 0, 0, 0.7)'
            }}>
              {slide.subtitle}
            </h1>

            <p style={{
              fontSize: '1.3rem',
              lineHeight: '1.6',
              color: '#e2e8f0',
              fontWeight: '400',
              margin: '0 auto 2rem auto',
              maxWidth: '700px'
            }}>
              {slide.description}
            </p>

            <div style={{
              display: 'flex',
              gap: '1.5rem',
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginBottom: '3rem'
            }}>
              <button style={{
                background: `linear-gradient(135deg, ${slide.gradientFrom}, ${slide.gradientTo})`,
                color: '#ffffff',
                padding: '1rem 2.5rem',
                borderRadius: '50px',
                border: 'none',
                fontWeight: '600',
                fontSize: '1.1rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                letterSpacing: '0.5px'
              }}
              onClick={handleStartInvestment}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = `0 15px 35px ${slide.accentColor}40`;
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}>
                Start Your Investment
              </button>

              <button style={{
                background: 'transparent',
                color: '#ffffff',
                padding: '1rem 2.5rem',
                borderRadius: '50px',
                border: `2px solid ${slide.accentColor}`,
                fontWeight: '600',
                fontSize: '1.1rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                letterSpacing: '0.5px'
              }}
              onClick={handleLearnMore}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = slide.accentColor;
                e.target.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.transform = 'translateY(0)';
              }}>
                Learn More
              </button>
            </div>

            <div style={{
              display: 'flex',
              gap: '3rem',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              {[
                { icon: '🌱', value: 'Organic', label: 'Farming Methods' },
                { icon: '💰', value: 'Guaranteed', label: 'Returns' },
                { icon: '🌍', value: 'Sustainable', label: 'Agriculture' }
              ].map((feature, idx) => (
                <div key={idx} style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>
                    {feature.icon}
                  </div>
                  <div style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: slide.accentColor,
                    marginBottom: '0.3rem'
                  }}>{feature.value}</div>
                  <div style={{
                    fontSize: '0.9rem',
                    color: '#cbd5e1',
                    fontWeight: '500'
                  }}>{feature.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    if (slide.type === "team") {
      return (
        <div style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div style={{
            textAlign: 'center',
            opacity: isActive ? 1 : 0,
            transform: isActive ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 1.2s cubic-bezier(0.25, 0.1, 0.25, 1) 0.3s',
            width: '100%'
          }}>
            <h1 style={{
              fontSize: '3.2rem',
              fontWeight: '800',
              marginBottom: '0.8rem',
              lineHeight: '1.1',
              color: '#ffffff',
              letterSpacing: '-0.02em'
            }}>
              {slide.title}
            </h1>

            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.6',
              color: '#e2e8f0',
              fontWeight: '400',
              margin: '0 0 3rem 0',
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>
              {slide.subtitle}
            </p>

          </div>
        </div>
      );
    }

    // Default slides for farming and produce
    return (
      <div style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        <div style={{
          maxWidth: '700px',
          opacity: isActive ? 1 : 0,
          transform: isActive ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 1.2s cubic-bezier(0.25, 0.1, 0.25, 1) 0.3s'
        }}>
          <div style={{
            position: 'relative',
            width: '80px',
            height: '80px',
            background: `linear-gradient(135deg, ${slide.accentColor}20 0%, ${slide.accentColor}10 100%)`,
            border: `3px solid ${slide.accentColor}60`,
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '2rem',
            fontSize: '2rem'
          }}>
            {slide.type === "farming" ? "🌿" : "🥬"}
          </div>

          <h1 style={{
            fontSize: '3.2rem',
            fontWeight: '800',
            marginBottom: '1rem',
            lineHeight: '1.1',
            color: '#ffffff',
            letterSpacing: '-0.02em'
          }}>
            {slide.title}
          </h1>

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: slide.accentColor,
            marginBottom: '1.5rem',
            letterSpacing: '0.5px'
          }}>
            {slide.subtitle}
          </h2>

          <p style={{
            fontSize: '1.2rem',
            lineHeight: '1.7',
            color: '#e2e8f0',
            fontWeight: '400',
            margin: '0 0 2.5rem 0',
            maxWidth: '600px'
          }}>
            {slide.description}
          </p>

          <div style={{
            display: 'flex',
            gap: '1.5rem',
            flexWrap: 'wrap',
            marginBottom: '2rem'
          }}>
            <button style={{
              background: `linear-gradient(135deg, ${slide.gradientFrom}, ${slide.gradientTo})`,
              color: '#ffffff',
              padding: '1rem 2rem',
              borderRadius: '12px',
              border: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onClick={handleExploreFarm}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-3px)';
              e.target.style.boxShadow = `0 12px 30px ${slide.accentColor}40`;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}>
              Explore Our Farm
            </button>

            <button style={{
              background: 'transparent',
              color: '#ffffff',
              padding: '1rem 2rem',
              borderRadius: '12px',
              border: `2px solid ${slide.accentColor}60`,
              fontWeight: '600',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onClick={handleContactUs}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = `${slide.accentColor}15`;
              e.target.style.borderColor = slide.accentColor;
              e.target.style.transform = 'translateY(-3px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = `${slide.accentColor}60`;
              e.target.style.transform = 'translateY(0)';
            }}>
              Contact Us
            </button>
          </div>

          <div style={{
            display: 'flex',
            gap: '2.5rem',
            flexWrap: 'wrap'
          }}>
            {(slide.type === "farming" ? [
              { value: '100%', label: 'Organic Certified' },
              { value: '500+', label: 'Acres Farmland' },
              { value: '50+', label: 'Crop Varieties' }
            ] : [
              { value: 'Fresh', label: 'Daily Harvest' },
              { value: 'Zero', label: 'Chemicals Used' },
              { value: '24hrs', label: 'Farm to Table' }
            ]).map((statItem, idx) => (
              <div key={idx} style={{ textAlign: 'left' }}>
                <div style={{
                  width: '40px',
                  height: '3px',
                  background: slide.accentColor,
                  marginBottom: '0.5rem'
                }} />
                <div style={{
                  fontSize: '2.2rem',
                  fontWeight: '700',
                  color: '#ffffff',
                  marginBottom: '0.3rem'
                }}>{statItem.value}</div>
                <div style={{
                  fontSize: '0.9rem',
                  color: '#94a3b8',
                  fontWeight: '500'
                }}>{statItem.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <section style={{
      height: '85vh',
      minHeight: '600px',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: '#0a0a0a'
    }}>
      <div style={{
        position: 'absolute',
        inset: 0,
        background: `
          radial-gradient(circle at 20% 30%, ${currentSlideData.accentColor}15 0%, transparent 50%),
          radial-gradient(circle at 80% 70%, ${currentSlideData.accentColor}10 0%, transparent 50%)
        `,
        transition: 'background 1.2s ease'
      }} />

      <div style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        transition: 'transform 1.2s cubic-bezier(0.25, 0.1, 0.25, 1)',
        transform: `translateX(-${currentSlide * 100}%)`
      }}>
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            style={{
              minWidth: '100%',
              height: '100%',
              position: 'relative',
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div style={{
              position: 'absolute',
              inset: 0,
              background: `
                linear-gradient(135deg, 
                  rgba(0, 0, 0, 0.7) 0%, 
                  rgba(0, 0, 0, 0.5) 50%, 
                  rgba(0, 0, 0, 0.6) 100%
                ),
                linear-gradient(90deg, 
                  rgba(0, 0, 0, 0.8) 0%, 
                  transparent 60%
                )
              `
            }}>
              {renderSlideContent(slide, index)}
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={goToPrevious}
        style={{
          position: 'absolute',
          left: '2rem',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(0, 0, 0, 0.7)',
          border: `2px solid ${currentSlideData.accentColor}40`,
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '1.5rem',
          color: '#ffffff',
          transition: 'all 0.3s ease',
          zIndex: 10
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = currentSlideData.accentColor;
          e.target.style.color = '#000000';
          e.target.style.borderColor = currentSlideData.accentColor;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
          e.target.style.color = '#ffffff';
          e.target.style.borderColor = `${currentSlideData.accentColor}40`;
        }}
      >
        ‹
      </button>

      <button
        onClick={goToNext}
        style={{
          position: 'absolute',
          right: '2rem',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(0, 0, 0, 0.7)',
          border: `2px solid ${currentSlideData.accentColor}40`,
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '1.5rem',
          color: '#ffffff',
          transition: 'all 0.3s ease',
          zIndex: 10
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = currentSlideData.accentColor;
          e.target.style.color = '#000000';
          e.target.style.borderColor = currentSlideData.accentColor;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
          e.target.style.color = '#ffffff';
          e.target.style.borderColor = `${currentSlideData.accentColor}40`;
        }}
      >
        ›
      </button>

      <div style={{
        position: 'absolute',
        bottom: '2rem',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '1rem',
        zIndex: 10
      }}>
        {slides.map((slide, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            style={{
              width: index === currentSlide ? '40px' : '12px',
              height: '12px',
              borderRadius: '6px',
              border: 'none',
              background: index === currentSlide
                ? `linear-gradient(135deg, ${slide.accentColor}, ${slide.gradientTo})`
                : 'rgba(255, 255, 255, 0.3)',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          />
        ))}
      </div>

      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '100%',
        height: '4px',
        background: 'rgba(255, 255, 255, 0.1)',
        zIndex: 10
      }}>
        <div style={{
          height: '100%',
          background: `linear-gradient(90deg, ${currentSlideData.accentColor}, ${currentSlideData.gradientTo})`,
          width: `${((currentSlide + 1) / slides.length) * 100}%`,
          transition: 'all 0.6s ease'
        }} />
      </div>

      <style>{`
        @media (max-width: 768px) {
          section h1 {
            font-size: 2.5rem !important;
          }
        }
        
        @media (max-width: 480px) {
          section h1 {
            font-size: 2rem !important;
          }
        }
      `}</style>
    </section>
  );
};

export default HeroCarousel;